import { Injectable } from '@angular/core';
import { AppSettings } from '../../proyect.conf';
import { HttpClient } from '@angular/common/http';
import { AutenticacionService } from './autenticacion.service';
import { map } from 'rxjs/operators';
import { ExcepcionGMFTipoCredito } from '../_models/excepcion-gmf-tipo-credito';
import {ExcepcionGMFFormaDesembolso} from '../_models/excepcion-gmf-forma-desembolso';

@Injectable({
  providedIn: 'root'
})
export class ExcepcionGMFFormaDesembolsoService {
  private rutServicio = AppSettings.rutServiciosAPL + '/api/excepcionesGMFFormasDesembolsos';

  constructor( private httClient: HttpClient, private autServicio: AutenticacionService ) {
  }

  listado() {
    return this.httClient.get( this.rutServicio ).pipe( map( res => res as ExcepcionGMFFormaDesembolso [] ) );
  }

  listadoHabilitados() {
    return this.httClient.get( this.rutServicio + '/enabled' ).pipe( map( res => res as ExcepcionGMFFormaDesembolso [] ) );
  }

  obtenerPorId( id: string ) {
    return this.httClient.get( this.rutServicio + '/' + id ).pipe( map( res => res as ExcepcionGMFFormaDesembolso ) );
  }

  crear( regCrear: ExcepcionGMFFormaDesembolso ) {
    regCrear.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.post( this.rutServicio, regCrear ).pipe( map( res => res as ExcepcionGMFFormaDesembolso ) );
  }

  actualizar( regActualizar: ExcepcionGMFFormaDesembolso ) {
    regActualizar.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.post( this.rutServicio, regActualizar ).pipe( map( res => res as ExcepcionGMFFormaDesembolso ) );
  }
  obtenerPorIdExcepcionGMF( id: string ) {
    return this.httClient.get( this.rutServicio + '/excepcion/' + id ).pipe( map( res => res as ExcepcionGMFFormaDesembolso ) );
  }

  obtenerPorIdExcepcionGMFHabilitado( id: string ) {
    return this.httClient.get( this.rutServicio + '/excepcion/' + id + '/enabled' ).pipe( map( res => res as ExcepcionGMFFormaDesembolso ) );
  }
}
